define('components/handlers/analytics',[
    'components/decorator',
    'jquery'
],function(
    decorator,
    $
){

    $.extend(companyInfo.handlers, {

        'analytics': function (e) {
            var params = getParams(this);
            analytics(params);
        },
        'analytics-follow-delete': function (e) {
            //check that the delete button in the followlist is clicked. if so. do analytics event
            var clickedElm = $(e.target);
            var parents = clickedElm.parents('button');
            if(parents.length ==1 ){
               clickedElm = $(parents[0]);
            }
            if(clickedElm.data("delete-category")){
                var category = clickedElm.data("delete-category");
                analytics(["user settings","remove from follow list",category]);
            }
        },

        'analytics-follow-add': function (e) {
            //check that the add button in the followlist is clicked. if so. do analytics event
            var clickedElm = $(e.target);
            var parents = clickedElm.parents('button');
            if(parents.length ==1 ){
               clickedElm = $(parents[0]);
            }

            if(clickedElm.data("add-category")){
                var category = clickedElm.data("add-category");
                analytics(["user settings","add to follow list",category]);
            }
        },
        'analytics-searchresult': function (e) {
            var $component = $(this);
            var clickedElm = $(e.target);
            var count; // =undefined;

            //check if the element is a link or part of a link, if not return false
            if(!checkElmLink(clickedElm, true) && !checkElmButton(clickedElm)){
                return false;
            }

            var parents = clickedElm.parents('a');
            if(parents.length ==1 ){
               clickedElm = $(parents[0]);
            }

            //check that the link is a searchresult
            //so not a link in tabs or in table header
            //tab-navigation
            if(clickedElm.parents(".tab-navigation").length || clickedElm.parents("thead").length){
                return false;
            }

            //find the searchresultcount
            var searchCount = $("[data-search-result-count]");
            if(searchCount.length){
                count = parseInt(searchCount.attr("data-search-result-count"));
                analytics(["internal links","click searchresult", undefined, count, undefined]);
            }

        },
        'analytics-internallinks': function (e) {
            var $component = $(this);
            var panelTitle = $component.data("analytics-panelname");

            /**
             * when an internal link is clicked, push an analytics event
             */
             var clickedElm = $(e.target);
             if(checkInternalLink(clickedElm)) {
                analytics(["internal links","click link", panelTitle, undefined, false]);
             }


        }

    });

    /**
     * check if there are data-analytics events, that need to push data when page is loaded
     */
    $(window).load(function(){
        $("[data-analytics-load]").each(function(){
            var params = getParams(this);
            analytics(params);
        });

        /**
         * After the page is loaded, we are pushing extra data that we can read from the page html
         */
        if (typeof dataLayer !== "undefined"){
            // dataLayer.push({
            //     event: 'dlReady',
            //     cookieAccept: acceptsCookie(),
            //     pageNotification: pageNotification()
            // });
        }
    });

    function analytics(params){
        params = getParams(null, params);
        if (typeof analyticsEvent !== "undefined") {
            analyticsEvent.apply(null, params);
        }
    }

    function getParams(elm, params){
        if(elm !== null){
          var component = $(elm);
          params = component.data('analytics-params');
          if(!params){
              params = [];
          }
        }

        if(typeof(params)==="string"){
           

            params = params.split(",");
            //trim the spaces from the Records
            for(var i=0; i<params.length;i++){
                var param = params[i];
                param = myTrim(param);
                params[i] = param;
            }

        }
        return params;
    }

    function myTrim(x) {
        return x.replace(/^\s+|\s+$/gm,'');
    }



    /**
     * Checks if the string is an internal or external url
     * @param  {url} href the url to test
     * @return {boolean}      true if its an internal link
     */
    function checkInternalLink (elm){
        //check if the element is a link or part of a link, if not return false
        if(!checkElmLink(elm)){
            return false;
        }

        var parents = elm.parents('a');
        if(parents.length ==1 ){
           elm = $(parents[0]);
        }
        //check if the link is internal
       var siteURL = "http://" + top.location.host.toString();
       if(elm.is("a[href^='"+siteURL+"'], a[href^='/'], a[href^='./'], a[href^='../']")){
           return true;
       }

       return false;
    }

    /**
     * this checks if the given element is an Atag or part of an Atag
     * @param  {[type]} elm [description]
     * @return {[type]}     [description]
     */
    function checkElmLink(elm, showfileDownload){
        var parents = elm.parents('a');
        if(parents.length ==1 ){
           elm = $(parents[0]);
        }



        //check that the link is not part of an admin panel
        if(elm.parents('.panel-editing').length == 1){
            return false;
        }

        //check that its not a download
        //file-download
        if(elm.is("a.file-download") && !showfileDownload){
            return false;
        }

        if(elm.prop("tagName").toLowerCase() === "a"){
            return true;
        }

        return false;
    }

    /**
     * this checks if the given element is a button
     * @param  {element} elm the clicked element
     * @return {boolean}
     */
    function checkElmButton(elm){
        var parents = elm.parents('button');
        if(parents.length ==1 ){
           elm = $(parents[0]);
        }

        //check that the link is not part of an admin panel
        if(elm.parents('.panel-editing').length == 1){
            return false;
        }

        //check that its not a download
        //file-download
        if(elm.is("a.file-download")){
            return false;
        }

        if(elm.prop("tagName").toLowerCase() === "button"){
            return true;
        }

        return false;
    }


    /**
     * Checks if the browser accepts cookies
     * @return {boolean} does the browser accept cookies?
     */
    function acceptsCookie(){
        return navigator.cookieEnabled;
    }

    /**
     * Return the pagenotification when there is an error.
     * It checks on the data-error attribute on the title
     * @return {string} return string if there is an error
     */
    function pageNotification(){
        var dataError = $("[data-error]");
        if(dataError.length){
            return dataError.attr("data-error");
        }
        return undefined;
    }

    /**
     * When there is a page which is showing searchResults set this in the datalayer
     * It checks on the data-error attribute on the title
     * @return {integer} return integer if there is a count
     */
    function searchResultCount(){
        var searchCount = $("[data-search-result-count]");
        if(searchCount.length){
            var count = parseInt(searchCount.attr("data-search-result-count"));
            return count;
        }
        return undefined;
    }
    $(window).load(function() {
        /**
         * After the page is loaded, we are pushing extra data that we can read from the page html
         */
        if (typeof datalayer !== "undefined") {
            // dataLayer.push({
            //     event: 'dlReady',
            //     cookieAccept: acceptsCookie(),
            //     pageNotification: pageNotification(),
            //     searchResultCount: searchResultCount() //not implemented yet
            // })
        }
    });

    return analytics;

});

